let stack = [];
let listeners = new Set();
let escapeListenerInitialized = false;

export const ModalStackManager = {
  addModal(modal) {
    stack.push(modal);
    this.notify();
  },

  removeModal(modalId) {
    stack = stack.filter(m => m.id !== modalId);
    this.notify();
  },

  getTopModal() {
    return stack[stack.length - 1];
  },

  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  notify() {
    for (const listener of listeners) {
      listener(stack[stack.length - 1]);
    }
  },

  initGlobalEscapeListener() {
    if (escapeListenerInitialized) return;

    if (typeof window !== 'undefined') {
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const top = this.getTopModal();
          if (top?.onClose) {
            top.onClose();
          }
        }
      });

      escapeListenerInitialized = true;
    }
  }
};
